/*
 * Product card hover gallery
 * Dawn's CSS already swaps a card to its second photo on hover. For cards
 * whose media carries data-hover-gallery (3+ photos, see card-product.liquid),
 * this keeps going: every INTERVAL it crossfades to the next photo, wrapping
 * back round through the first, until the pointer leaves the card.
 *
 * Two layer <img>s are stacked over Dawn's own and take turns: the next photo
 * loads into the hidden one, which fades in only once it has decoded, so a
 * slow image never flashes blank. Delegated from document, so cards added
 * later (collection filtering, infinite scroll) work without re-binding.
 * Desktop pointers only — the same 990px floor Dawn's hover swap uses.
 */
(() => {
  const INTERVAL = 1200;
  const canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');

  let active = null; // { card, media, layers, front, index, sources, timer }

  function start(card) {
    const media = card.querySelector('.media[data-hover-gallery]');
    if (!media) return;

    const sources = media.dataset.hoverGallery.split(';').filter(Boolean);
    if (sources.length < 3) return;

    // Lay the layers over Dawn's images, borrowing their sizes attribute
    const sizes = media.querySelector('img')?.getAttribute('sizes') || '';
    const layers = [0, 1].map(() => {
      const img = document.createElement('img');
      img.className = 'card-gallery-layer';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.sizes = sizes;
      media.appendChild(img);
      return img;
    });

    // Index 1 is already on screen via Dawn's CSS swap, so start after it
    active = { card, media, layers, front: 0, index: 1, sources, timer: null };
    active.timer = window.setInterval(advance, INTERVAL);
  }

  function advance() {
    const state = active;
    if (!state) return;

    state.index = (state.index + 1) % state.sources.length;
    const incoming = state.layers[1 - state.front];
    const outgoing = state.layers[state.front];

    incoming.srcset = state.sources[state.index];
    const show = () => {
      if (active !== state) return; // pointer left while it was loading
      incoming.classList.add('is-visible');
      outgoing.classList.remove('is-visible');
      state.front = 1 - state.front;
    };
    incoming.decode ? incoming.decode().then(show, show) : show();
  }

  function stop() {
    if (!active) return;
    window.clearInterval(active.timer);
    active.layers.forEach((layer) => layer.remove());
    active = null;
  }

  document.addEventListener('mouseover', (event) => {
    if (!canHover.matches) return;
    const card = event.target.closest('.card-wrapper');
    if (!card || card === active?.card) return;
    stop();
    start(card);
  });

  document.addEventListener('mouseout', (event) => {
    if (!active) return;
    if (event.relatedTarget && active.card.contains(event.relatedTarget)) return;
    stop();
  });
})();
